import { render, staticRenderFns } from "./SystemMessagesDrawer.vue?vue&type=template&id=5c38e000&scoped=true&"
import script from "./SystemMessagesDrawer.vue?vue&type=script&lang=js&"
export * from "./SystemMessagesDrawer.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessagesDrawer.vue?vue&type=style&index=0&id=5c38e000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c38e000",
  null
  
)

export default component.exports